import axios from 'axios';

import { setLoading, setMessage } from '../actions/userActions';
import { store } from '../index';
import {
  AUTHORIZATION_NOT_FOUND,
  GENERIC_ERROR_MESSAGE,
  MAINTENANCE,
  MULTIPLE_SESSION_ERROR,
  SESSION_EXPIRED,
  SESSION_NOT_FOUND,
} from './constants';
import history from './history';

export default function tokenExpiredOrMaintenanceInterceptor() {
  const unhautorizedErrorStatus = 401;
  const maintenanceErrorStatus = 503;
  const errorMessages = [
    AUTHORIZATION_NOT_FOUND,
    GENERIC_ERROR_MESSAGE,
    MULTIPLE_SESSION_ERROR,
    SESSION_NOT_FOUND,
    SESSION_EXPIRED,
    MAINTENANCE,
  ];
  axios.defaults.withCredentials = true;
  axios.interceptors.request.use((config) => {
    if (!config.headers['app-type']) {
      config.headers['app-type'] = 'student';
    }
    return config;
  });
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (!error.response) return Promise.reject(error);

      const { status, data } = error.response;

      if (
        typeof data === 'object' &&
        'err' in data &&
        errorMessages.includes(data.err)
      ) {
        if (status === unhautorizedErrorStatus) {
          store.dispatch(setMessage(data.err));
          store.dispatch(setLoading(false));
          history.push('/login');
        } else if (status === maintenanceErrorStatus) {
          history.push('/maintenance');
        }
      }
      return Promise.reject(error);
    },
  );
}
